module.exports = __webpack_public_path__ + "static/media/dew.0b35c5f9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/dew.gif
// module id = 250
// module chunks = 0